import React, { useState } from "react";
import { questionsAndAnswers } from "../utils/QuestionsAndAnswers";

const AccordionArea = ({ page }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const filteredQuestions = questionsAndAnswers.filter((item) =>
    item.visibleIn.includes(page)
  );
  return (
    <div className="flex flex-col gap-8">
      {filteredQuestions.map((item, index) => (
        <div
          className={`accordionItem p-4 cursor-pointer ${
            page === "home"
              ? " p-dark-style"
              : "p-light-style p-4 shadow-cardShadow hover:shadow-hoverShadow  rounded-2xl w-full "
          }`}
          key={item.id || `question-${item.question}`}
          onClick={() => toggleAccordion(index)}
        >
          <div className="flex justify-between items-center gap-4">
            <h3
              className={`accordionHeader font-semibold ${
                page === "home" ? "text-white" : "text-grayy"
              }`}
            >
              {index + 1}. {item.question}
            </h3>
            <img
              src={
                activeIndex !== index && page === "home"
                  ? "/Close.svg"
                  : activeIndex !== index
                  ? "Closeg.svg"
                  : page === "home"
                  ? "/carpi.svg"
                  : "Carpig.svg"
              }
              alt="Accordion Area Image"
            />
          </div>
          <div
            className={`accordionContent mt-4 text-sm font-normal leading-[22px] text-left transition-all duration-300 ${
              activeIndex === index ? "block" : "hidden"
            }`}
          >
            {Array.isArray(item.answer) ? (
              <ul className="list-none flex flex-col gap-2">
                {item.answer.map((line, i) => (
                  <li key={i}>{line}</li>
                ))}
              </ul>
            ) : (
              <p>{item.answer}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AccordionArea;
